export const MCAP_QUERY_KEY = 'mcap' as const;

/** Stable id of the always-present operational ("Workspace") timeline lane. */
export const WORKSPACE_LANE_ID = 'workspace';

/** Matches compact reference tracks so segment bars fill their lanes without expanding the panel. */
export const MCAP_TIMELINE_LANE_HEIGHT = 26;

/**
 * Max timeline lanes visible at once on the asset detail page; extra lanes scroll
 * vertically within a fixed-height viewport so the timeline doesn't grow unbounded.
 */
export const MAX_VISIBLE_TIMELINE_LANES = 5;
export const MCAP_MEDIA_TYPE = 'application/vnd.mcap' as const;
export const MCAP_UPLOAD_CHUNK_BYTES = 32 * 1024 * 1024;
export const ACTIVE_STATUS_POLL_MS = 2_000;
export const MCAP_INGEST_NOT_FOUND_RETRIES = 4;
export const MCAP_STATUS_OTHER_RETRIES = 2;

// Viewer/inspector split, sized as a fraction of the workspace row (proportional,
// like the v1 Annotator Editor split): the viewer pane takes this share of the width
// and the inspector fills the rest. Bounds match the v1 editor's video-pane clamps.
export const VIEWER_PANE_MIN_FRACTION = 0.38;
export const VIEWER_PANE_MAX_FRACTION = 0.78;
export const VIEWER_PANE_INITIAL_FRACTION = 0.7;

// Rosview renders Image panels in a worker, so this must be a concrete canvas color rather than
// a CSS token. White fills only the unused area left by the panel's `contain` fit mode.
export const ROSVIEW_CAMERA_BACKGROUND_COLOR = '#ffffff';

/** One automatic lease recovery per incident prevents a bad credential from causing a remount loop. */
export const MCAP_MAX_AUTOMATIC_LEASE_RECOVERY_ATTEMPTS = 1;
